import { USER_ROLES } from './acl/user';
import type { USER_ROLE } from './acl/user';

export enum SearchMode {
    AND = 'AND',
    OR = 'OR',
}

export enum SearchType {
    GLOBAL = 'global',
    USER = 'user',
}

// roles whose regular search already covers all leads
export const ROLES_WITHOUT_GLOBAL_SEARCH: ReadonlyArray<USER_ROLE> = [USER_ROLES.admin, USER_ROLES.email_manager];
